module.exports = __webpack_public_path__ + "static/5-129c77096c99c5c46b7380a440e5885b.jpg";